// Single source of truth for visit-method display labels and the helpers that
// convert between API flags ↔ label strings.
// Kept here to avoid the view-mode / form duplication that previously caused
// a capital-P / lowercase-p label mismatch.

export const VISIT_METHOD_IN_PERSON = 'In-person visit'
export const VISIT_METHOD_VIDEO_PHONE = 'Video & Phone call'
export const VISIT_METHOD_VIDEO_ONLY = 'Video only'
// Async ("Offline") visits — the visit type carries the mutually-exclusive
// IsAsynchronous flag rather than a Method string. See QMD-3775.
export const VISIT_METHOD_OFFLINE_ASYNC = 'Offline (async)'

/**
 * Derive the display label from the visit-type API flags.
 * Moved verbatim from VisitTypeViewMode.tsx.
 */
export function getVisitMethod(visitType: {
  IsInPerson?: boolean | null
  IsPhoneVisitCommunicationTypeAllowed?: boolean | null
  IsAsynchronous?: boolean | null
}): string {
  if (visitType.IsAsynchronous) return VISIT_METHOD_OFFLINE_ASYNC
  if (visitType.IsInPerson) return VISIT_METHOD_IN_PERSON
  if (visitType.IsPhoneVisitCommunicationTypeAllowed) return VISIT_METHOD_VIDEO_PHONE
  return VISIT_METHOD_VIDEO_ONLY
}

/**
 * Reverse mapping: given a label string, return the mutually-exclusive boolean flags.
 * Mirrors the onChange logic in VisitTypeForm.tsx exactly.
 */
export function visitMethodToFlags(label: string): {
  IsInPerson: boolean
  IsPhoneVisitCommunicationTypeAllowed: boolean
  IsAsynchronous: boolean
} {
  return {
    IsInPerson: label === VISIT_METHOD_IN_PERSON,
    IsPhoneVisitCommunicationTypeAllowed: label === VISIT_METHOD_VIDEO_PHONE,
    IsAsynchronous: label === VISIT_METHOD_OFFLINE_ASYNC,
  }
}
